import { render, staticRenderFns } from "./MobileFooter.vue?vue&type=template&id=886b9fd6&scoped=true"
import script from "./MobileFooter.vue?vue&type=script&lang=js"
export * from "./MobileFooter.vue?vue&type=script&lang=js"
import style0 from "./MobileFooter.vue?vue&type=style&index=0&id=886b9fd6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886b9fd6",
  null
  
)

export default component.exports